var _rect, _rect2, _rect3, _rect4, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeoFences(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.6,
    y: 0.800195,
    width: 70,
    height: 70,
    rx: 35,
    stroke: "url(#paint0_linear_706_71257)",
    strokeWidth: 1.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.6,
    y: 0.800195,
    width: 70,
    height: 70,
    rx: 35,
    stroke: "url(#paint1_linear_706_71257)",
    strokeWidth: 1.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.1996,
    y: 10.3998,
    width: 50.8,
    height: 50.8,
    rx: 25.4,
    stroke: "url(#paint2_linear_706_71257)",
    strokeWidth: 1.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10.1996,
    y: 10.3998,
    width: 50.8,
    height: 50.8,
    rx: 25.4,
    stroke: "url(#paint3_linear_706_71257)",
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0444 35.4073C23.9133 38.3068 26.2145 41.6962 27.9732 43.79C28.0625 43.8964 28.1574 43.9817 28.2917 43.9817C28.4261 43.9817 28.5175 43.893 28.6103 43.79C30.4854 41.7089 32.6246 38.4558 32.5421 35.4911C32.4744 33.0639 30.5974 31.1184 28.2917 31.1184C26.0127 31.1184 24.1524 33.0194 24.0444 35.4073ZM43.2792 45.7565C43.2792 45.9591 43.115 46.1232 42.9124 46.1232C42.7099 46.1232 42.5457 45.9591 42.5457 45.7565V45.1445C42.5457 44.9419 42.7099 44.7777 42.9124 44.7777C43.115 44.7777 43.2792 44.9419 43.2792 45.1445V45.7565ZM28.6584 45.7565C28.6584 45.9591 28.4942 46.1232 28.2917 46.1232C28.0891 46.1232 27.9249 45.9591 27.9249 45.7565V45.1445C27.9249 44.9419 28.0891 44.7777 28.2917 44.7777C28.4942 44.7777 28.6584 44.9419 28.6584 45.1445V45.7565ZM43.2792 38.8819C43.2792 39.0845 43.115 39.2487 42.9124 39.2487C42.7099 39.2487 42.5457 39.0845 42.5457 38.8819V38.27C42.5457 38.0674 42.7099 37.9032 42.9124 37.9032C43.115 37.9032 43.2792 38.0674 43.2792 38.27V38.8819ZM41.9323 39.9278C42.1348 39.9278 42.299 40.092 42.299 40.2945C42.299 40.4971 42.1348 40.6613 41.9323 40.6613H41.3203C41.1177 40.6613 40.9535 40.4971 40.9535 40.2945C40.9535 40.092 41.1177 39.9278 41.3203 39.9278H41.9323ZM39.4844 39.9278C39.6869 39.9278 39.8511 40.092 39.8511 40.2945C39.8511 40.4971 39.6869 40.6613 39.4844 40.6613H38.8724C38.6698 40.6613 38.5056 40.4971 38.5056 40.2945C38.5056 40.092 38.6698 39.9278 38.8724 39.9278H39.4844ZM36.8621 39.9278C37.0646 39.9278 37.2288 40.092 37.2288 40.2945C37.2288 40.4971 37.0646 40.6613 36.8621 40.6613H36.2501C36.0475 40.6613 35.8833 40.4971 35.8833 40.2945C35.8833 40.092 36.0475 39.9278 36.2501 39.9278H36.8621ZM35.6368 42.3192C35.6368 42.5217 35.4726 42.6859 35.27 42.6859C35.0675 42.6859 34.9033 42.5217 34.9033 42.3192V41.7071C34.9033 41.5046 35.0675 41.3404 35.27 41.3404C35.4726 41.3404 35.6368 41.5046 35.6368 41.7071V42.3192ZM36.2501 44.0986C36.0475 44.0986 35.8833 43.9344 35.8833 43.7318C35.8833 43.5293 36.0475 43.3651 36.2501 43.3651H36.8621C37.0646 43.3651 37.2288 43.5293 37.2288 43.7318C37.2288 43.9344 37.0646 44.0986 36.8621 44.0986H36.2501ZM38.8724 44.0986C38.6698 44.0986 38.5056 43.9344 38.5056 43.7318C38.5056 43.5293 38.6698 43.3651 38.8724 43.3651H39.4844C39.6869 43.3651 39.8511 43.5293 39.8511 43.7318C39.8511 43.9344 39.6869 44.0986 39.4844 44.0986H38.8724ZM41.3203 44.0986C41.1178 44.0986 40.9536 43.9344 40.9536 43.7318C40.9536 43.5293 41.1178 43.3651 41.3203 43.3651H41.9323C42.1349 43.3651 42.2991 43.5293 42.2991 43.7318C42.2991 43.9344 42.1349 44.0986 41.9323 44.0986H41.3203ZM41.3203 47.5358C41.1178 47.5358 40.9536 47.3717 40.9536 47.1691C40.9536 46.9666 41.1178 46.8024 41.3203 46.8024H41.9323C42.1349 46.8024 42.2991 46.9666 42.2991 47.1691C42.2991 47.3717 42.1349 47.5358 41.9323 47.5358H41.3203ZM29.0805 47.5358C28.878 47.5358 28.7138 47.3717 28.7138 47.1691C28.7138 46.9666 28.878 46.8024 29.0805 46.8024H29.6925C29.8951 46.8024 30.0593 46.9666 30.0593 47.1691C30.0593 47.3717 29.8951 47.5358 29.6925 47.5358H29.0805ZM31.5284 47.5358C31.3259 47.5358 31.1617 47.3717 31.1617 47.1691C31.1617 46.9666 31.3259 46.8024 31.5284 46.8024H32.1405C32.343 46.8024 32.5072 46.9666 32.5072 47.1691C32.5072 47.3717 32.343 47.5358 32.1405 47.5358H31.5284ZM33.9764 47.5358C33.7739 47.5358 33.6097 47.3717 33.6097 47.1691C33.6097 46.9666 33.7739 46.8024 33.9764 46.8024H34.5884C34.791 46.8024 34.9552 46.9666 34.9552 47.1691C34.9552 47.3717 34.791 47.5358 34.5884 47.5358H33.9764ZM36.4243 47.5358C36.2218 47.5358 36.0576 47.3717 36.0576 47.1691C36.0576 46.9666 36.2218 46.8024 36.4243 46.8024H37.0364C37.2389 46.8024 37.4031 46.9666 37.4031 47.1691C37.4031 47.3717 37.2389 47.5358 37.0364 47.5358H36.4243ZM38.8723 47.5358C38.6698 47.5358 38.5056 47.3717 38.5056 47.1691C38.5056 46.9666 38.6698 46.8024 38.8723 46.8024H39.4843C39.6868 46.8024 39.851 46.9666 39.851 47.1691C39.851 47.3717 39.6868 47.5358 39.4843 47.5358H38.8723ZM38.66 28.3534C38.5289 31.2529 40.8301 34.6422 42.5887 36.7361C42.678 36.8424 42.773 36.9278 42.9073 36.9278C43.0416 36.9278 43.1331 36.8391 43.2259 36.7361C45.1009 34.655 47.2402 31.4019 47.1576 28.4372C47.0899 26.01 45.2129 24.0645 42.9073 24.0645C40.6283 24.0645 38.768 25.9654 38.66 28.3534ZM44.3034 29.8918C43.5324 30.6628 42.2822 30.6628 41.5112 29.8918C40.7402 29.1207 40.7402 27.8705 41.5112 27.0996C42.2822 26.3286 43.5324 26.3286 44.3034 27.0996C45.0744 27.8705 45.0744 29.1207 44.3034 29.8918ZM29.6878 36.9457C28.9168 37.7167 27.6666 37.7167 26.8956 36.9457C26.1246 36.1747 26.1246 34.9245 26.8956 34.1535C27.6666 33.3825 28.9168 33.3825 29.6878 34.1535C30.4588 34.9245 30.4588 36.1747 29.6878 36.9457Z",
    fill: "#009DDD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_706_71257",
    x1: 5.86098,
    y1: 75.3075,
    x2: 74.4561,
    y2: -4.57542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323723,
    stopColor: "#009DDD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_706_71257",
    x1: 70.9829,
    y1: -8.91687,
    x2: 5.86097,
    y2: 71.4002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576615,
    stopColor: "#009DDD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_706_71257",
    x1: 3.93832,
    y1: 12.7353,
    x2: 61.3899,
    y2: 61.7998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DDD",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323723,
    stopColor: "#009DDD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_706_71257",
    x1: 71.8738,
    y1: 73.5417,
    x2: 11.4867,
    y2: 30.7675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576615,
    stopColor: "#009DDD",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeoFences);
export default __webpack_public_path__ + "static/media/Geo_fences.1603880dfa3ffa782fc3f95d3b882e44.svg";
export { ForwardRef as ReactComponent };